import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  /* reset css */
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed, 
  figure, figcaption, footer, header, hgroup, 
  menu, nav, output, ruby, section, summary, main,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
    box-sizing: border-box;
  }
  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure, 
  footer, header, hgroup, menu, nav, section {
    display: block;
  }
  body {
    line-height: 1;
  }
  ol, ul {
    list-style: none;
  }
  blockquote, q {
    quotes: none;
  }
  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  /* custom global css */

  html {
    font-size: 15px;
  }

  body {
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu",
      "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
    font-family: 'Noto Sans KR', 'Roboto', sans-serif;
    background-color: #fafbfb;
    color: #304156;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  a {
    color : inherit;
    text-decoration: inherit;
  }

  .custom-scroll-bar {
    scroll-margin-right: 10px;
    &::-webkit-scrollbar{
      width: 5px;
    }

    &::-webkit-scrollbar-thumb {
      height: 15%;
      background-color: #D2D6DA;
      border-radius: 50px;
    }

    &::-webkit-scrollbar-track {
      border-radius: 50px;
      background-color: #F0F1F2;
    }
  }

  ::-moz-selection {
    background: #2EB7FF;
    color: #fff;
  }

  ::selection {
    background: #2EB7FF;
    color: #fff;
  }
`;
